
import { project_list, erns_list, tissue_list, kit_list, subproject_list } from '../../../service/apis';
import { experiments_view } from '../../../service/apis';
import { checkRowFilled } from '../components/UtilSubmissionTable';

export const isSolveRDSelected = currentFormControls => {
    // Return True if a SolveRD Project is selected
    for (let row of currentFormControls){
        for (let column of row){
            if (column.id === "Projects"){
                if (column.value.includes('Solve-RD')){
                    return true;
                }
            }
        }
    }
    return false;
}

export const isAnyMonths12 = currentFormControls => {
    //Return True if 12 months are selected in any row
    for (let row of currentFormControls){
        for (let column of row){
            if (column.id === "months"){
                if (column.value === "12"){
                    return true;
                }
            }
        }
    }
    return false;
}

export const isErderaSelected = currentFormControls => {
    // Return True if an ERDERA Project is selected
    for (let row of currentFormControls){
        for (let column of row){
            if (column.id === "Projects"){
                if (column.value.includes('ERDERA')){
                    return true;
                }
            }
        }
    }
    return false;
}

export const addEmbargoPeriodReason = currentFormControls => {
    //Add Embargo Reason Period to all Form Rows
    for (let row of currentFormControls){
        row.splice(4,0,{id:"embargoPeriodReason",index:row[0].index, value:'',error:''})
    }
}

export const removeEmbargoPeriodReason = (currentFormControls,index) => {
    //Remove Embargo Period Reason from all Form Rows
    for (let row of currentFormControls){
        row.splice(index, 1);
    }
}

export const parseSelectServerSide = (items,formItem,fieldId,valueChecked="") => {
    //Check data comming from server side API and try to update form field with new values
    if (items.length > 0){
        formItem.valueIndex = {value:0, label:items[0][fieldId]};
        formItem.value = items[0][fieldId];
        if (formItem.value !== "" && fieldId === "report_id") {
            formItem.error = "";
        }
    } else {
        if (formItem.value === "" && fieldId === "report_id"){
            formItem.error = valueChecked + " does not exits or you are not allowed to use it.";
        }
    }
};

export const fetchHeadersList = async (currentHeaders,token,apiEndpoint) => {
    // Project List
    let res = await project_list(token, apiEndpoint);
    let data = await res.json();
    let headerProject = currentHeaders.find(item => item.id === "Projects")
    headerProject.selection = data.filter((item) => item.allow_submission == true).map(item =>item.project_title);
    headerProject.selection.unshift("----");
    // ERNs List
    res = await erns_list(token, apiEndpoint);
    data = await res.json();
    let headerErns = currentHeaders.find(item => item.id === "erns")
    headerErns.selection = data.map(item =>item.name);
    headerErns.selection.unshift("----");
    // Tissue List
    res = await tissue_list(token, apiEndpoint);
    data = await res.json();
    let headerTissues = currentHeaders.find(item => item.id === "tissues")
    headerTissues.selection = data.map(item =>item.name);
    headerTissues.selection.unshift("----");
    // Kit List
    res = await kit_list(token, apiEndpoint);
    data = await res.json();
    let headerKit = currentHeaders.find(item => item.id === "kits")
    headerKit.selection = data.map(item =>item.kit_name);
    headerKit.selection.unshift("----");
    
    return currentHeaders;
};

export const fetchSubprojectList = async (currentHeaders, currentFormControls, token, apiEndpoint) => {  
    // Subproject list
    let res = await subproject_list(token,apiEndpoint);
    let data = await res.json();
    // Subroject header
    let headerSubproject = { 
        id:"Subprojects", title : "Subproject", inputType:"selectMultiple", 
        description:"Select if these samples belong to a specific subproject.",
        mandatory:false, selection : [], width: 220
    };
    for (let subproject of data){
        headerSubproject.selection.push(subproject.name);
    }
    headerSubproject.selection.unshift("----");
    // Insert Subprojects after projects
    let positonInsertion = currentHeaders.findIndex(item => item.id === "Projects") + 1;
    stateHeaders.splice(positonInsertion,0,headerSubproject);
    // CNAG BARCODE
    let headerBarcode = { 
        id:"cnag_barcode", title : "CNAG Barcode", inputType:"text", 
        description:"CNAG Barcode that identifies the sample.", 
        mandatory:false, width: 250, selection : [] 
    };
    // Insert CNAG Barcode after Subproject
    currentHeaders.splice(positonInsertion+1,0,headerBarcode);
    // Add Form Controls
    let ndx = 0;
    for (let row of currentFormControls) {
        row.splice(positonInsertion,0,{id:"Subprojects", index:ndx,value:[],error:'', options:[]});
        row.splice(positonInsertion+1,0,{id:"cnag_barcode", index:ndx,value:'',error:'', options:[]});
        ndx++;
    }
    return [currentHeaders, currentFormControls];
} 
           
export const validateForm = async (formControls, headers, experimentOwner, token, apiEndpoint) => {
    //Loop Form Controls
    for (let row of formControls){
        let checkRow = checkRowFilled(row, headers);
        for (let column of row){
            if (checkRow) {
                const value = column.value;
                //1. Check if the field is mandatory
                let columnHeader = headers.find(item => item.id === column.id);
                //1.0 Special case Embargo Period Reason
                if (column.id === "embargoPeriodReason") {
                    let fieldMonths = row.find(item => item.id === "months");
                    if (fieldMonths.value === "12" && column.value === "")  column.error = "This field is required.";
                    else column.error = "";
                }
                //1.1 Special case Local Experiment
                else if(column.id === "Experiment") {
                    //1.1.0 Check field does not have white spaces
                    if (value.includes(" ")) {
                        column.error = "White spaces are not allowed. "
                    } else {
                        column.error = "";
                    }
                    //1.1.1 Get Groups Fields
                    let groupOwner = experimentOwner;
                    //1.1.2 Get Participant Field
                    let participant = row.find(item => item.id === "Participant_ID").value;
                    //1.1.3 Query If it exists any experiment for the group Owner with the same Local Experiment ID
                    let data_query = {"page" : 1, "pageSize" : 100, "fields" : ["ExperimentID"],"filtered":[{"id":"LocalExperimentID","value":[value]},{"id":"Owner","value":[groupOwner]}]}
                    let response = await experiments_view(token,apiEndpoint, JSON.stringify(data_query))
                    let data = await response.json();
                    if (data["_meta"]["total_items"] > 0 ) {
                        column.error += "LocalExperimentID "+ value +" already used for group " + groupOwner + " ";
                    }
                    else {
                        column.error += "";
                    }
                    //1.1.4 Query if it exists any experiment for the Participant_ID ID with the same Local Experiment ID
                    data_query = {"page" : 1, "pageSize" : 100, "fields" : ["ExperimentID"],"filtered":[{"id":"LocalExperimentID","value":[value]},{"id":"Participant_ID","value":[participant]}]}
                    response =   await experiments_view(token,apiEndpoint,JSON.stringify(data_query))
                    data = await response.json();
                    if (data["_meta"]["total_items"] > 0 ) {
                        column.error += "LocalExperimentID "+ value +" already used for participant " + participant;
                    }
                    else {
                        column.error +="";
                    }
                }
                //1.3 Special case Library Strategy
                else if(column.id === "kits") {
                    //1.3.1 Get Library Strategey Field
                    let libraryStrategy = row.find(item => item.id === "LibraryStrategy").value;
                    //1.3.2 Get Kit Value
                    let kit = row.find(item => item.id === "kits").value;
                    //1.3.3 Check Library and Kit
                    if (kit && kit !== "----") {
                        if (libraryStrategy === "WGS" && kit !== "WGS") {
                            column.error = "Library Strategy is WGS so Kit must be WGS.";
                        }
                        else if (libraryStrategy === "WXS" && kit === "WGS") {
                            column.error = "Library Strategy is WXS so Kit can not be WGS.";
                        }
                        else {
                            column.error = "";
                        }
                    }
                    else if (kit === "----"){
                        column.error = "This field is required.";
                    }
                    else {
                        column.error = "";
                    }
                    //1.4.4 Library Strategy is Mandatory
                    if (kit === "") column.error = "This field is required.";
                }
                //1.4 Special case Kits
                else if (column.id === "LibraryStrategy") {
                  //1.4.1 Get Library Strategy and Kit field
                  let libraryStrategy = row.find(item => item.id === "LibraryStrategy").value;
                  let kit = row.find(item => item.id === "kits").value;
                  //1.3.3 Check Library and Kit
                  if (kit) {
                      if (kit === "WGS" && libraryStrategy !== "WGS"){
                          column.error ="Kit is WGS so Library Strategy must be WGS.";
                      }
                      else {
                          column.error = "";
                      }
                  }
                  else {
                      column.error = "";
                  }
                  //1.4.4 Library Strategy is Mandatory
                  if (libraryStrategy === "" || libraryStrategy === "----") column.error = "This field is required.";
                }
                else if (columnHeader.mandatory) {
                    if (Array.isArray(value)) {
                        //Check if selected values are valid options
                        let wrongValues = "";
                        for (let item of value) {
                            if(columnHeader.selection.indexOf(item) === -1 && item !== ""){
                                  wrongValues = wrongValues + " " + item;
                                  column.value.splice(column.value.indexOf(item), 1);
                            }
                        }
                        //Report errors
                        if (value.length === 0 || (value.length === 1 && (value[0] === "----" || value[0] === "")))
                        {
                            column.error = "This field is required.";
                        }
                        else if (wrongValues !== "") {
                            column.error = wrongValues + " not a valid options!!";
                        }
                        else {
                            column.error = "";
                        }
                    }
                    else {
                        //Check in case of Combobox if selected value is valid
                        if (value === "" || value === "----")
                        {
                            if (column.error === "" ) {
                                column.error = "This field is required.";
                            }
                        }
                        else if(columnHeader.selection.length > 1 && columnHeader.selection.indexOf(value) === -1) {
                            column.error = value + " is not a valid option!!";
                        }
                        else {
                            column.error = "";
                        }
                    }
                }
            }
            else {
                //If row is empty then clean old errors
                column.error = "";
            }
        }
    }
}   

export const getApiKey = rowId => {
    //From column ID to Management API key
    const keyLabels = [
        {key:"Experiment", label:"Submitter_ID"}, {key:"Projects", label:"project"}, {key:"months", label:"months_until_embargo"},
        {key:"tissues", label:"tissue"}, {key:"erns", label:"erns"}, {key:"LibraryStrategy", label:"library_strategy"},
        {key:"kits", label:"kit"}, {key:"EGA", label:"EGA_ID"}, {key:"LibraryIsize", label:"read_insert_size"},
        {key:"Subprojects", label:"subproject"}
    ]
    let apiKey = keyLabels.find((item) => item.key === rowId);
    if (apiKey === undefined) return rowId;
    else return apiKey.label;
}
   
